function isCignaPlan(plan: Plan): boolean {
  return plan.coreBenefits.networkProvider === 'cigna'
}

export default isCignaPlan
